import { Component, Input } from '@angular/core';
import { CustomerUser } from '@app/manage-users/models/customer-user.model';

@Component({
  selector: 'app-manage-users-list-section-expanded-view-modal',
  templateUrl: './manage-users-list-section-expanded-view-modal.component.html',
  styleUrls: ['./manage-users-list-section-expanded-view-modal.component.scss'],
})
export class ManageUsersListSectionExpandedViewModalComponent {
  @Input() user: CustomerUser;

  constructor() {}
}
